import UserTabWrapper from '../../components/userTabWrapper';

const UserPage = () => {
  return <UserTabWrapper />;
};

export default UserPage;